import React, { useState } from "react";
import Lightbox from "react-image-lightbox";
import {
  Grid,
  makeStyles,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  useMediaQuery,
  Link,
  Container,
  GridList,
  GridListTile,
  ImageList,
  ImageListItem,
  CircularProgress,
} from "@material-ui/core";
//import { Accordion, AccordionSummary, AccordionDetails  } from "@mui/material";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import _ from "lodash";
import { Button, Typography, Page, RoundedButton } from "@packages/ui";
import { useCurrentRental } from "src/hooks/rentalHooks";
import moment from "moment";
import { fileURL } from "../../env";
import JSZip from "jszip";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: 15,
    paddingBottom: theme.spacing(3),
  },
  details: {
    alignItems: "flex-start",
    minHeight: "50vh",
    flexWrap: "wrap",
  },
  detailsDirectionColumn: {
    alignItems: "flex-start",
    flexDirection: "column",
  },

  columnThird: {
    flexBasis: "33.33%",
  },
  columnFull: {
    flexBasis: "100%",
  },
  unOrderedList: {
    padding: "0 0 0 1.1em",
  },

  tab: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: "flex",
  },
  tabs: {
    borderRight: `0px solid ${theme.palette.divider}`,
    width: "70vw",
  },
}));
function isValidURL(s) {
  try {
    new URL(s);
    return true;
  } catch (err) {
    return false;
  }
}
function isS3Url(url) {
  return url.includes("hertz-damage-photos.s3") || url.includes("amazonaws.com/photos");
}
function encodeUrlFile(url) {
  try {
    const u = new URL(url);
    const parts = u.pathname.split("/");
    const encodedFilename = encodeURIComponent(parts.pop());
    return `${u.origin}${parts.join("/")}/${encodedFilename}`;
  } catch {
    return url;
  }
}
function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.style.display = "none";
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

const VIRAccordion = ({
  loading = false,
  rental,
  vir,
  classes,
  damagePhotos,
  damagePhotosPdf,
  damagePhotosZip,
  handleAlbumClick,
  downloadAllAttachments,
}) => {
  const incidentDateTime = moment(vir.incidentDetails.date);
  // Note: Incident time doesn't carry the timezone so it is implied as UTC
  const incideDateTimeString = !incidentDateTime.isValid()
    ? "No Date and Time Set"
    : incidentDateTime.format("MMM DD, YYYY HH:mm");
  const damageDescriptionEmpty =
    !Boolean(vir.damageDetails) ||
    !Boolean(vir.damageDetails.damageCodes) ||
    vir.damageDetails.damageCodes.length === 0;
  const damagePhotosEmpty = !Boolean(damagePhotos) || damagePhotos.length === 0;
  const damagePhotosPdfEmpty = !Boolean(damagePhotosPdf) || damagePhotosPdf.length === 0;
  const damagePhotosZipEmpty = !Boolean(damagePhotosZip) || damagePhotosZip.length === 0;
  const incidentReportsEmpty = !Boolean(vir.incidentReports) || vir.incidentReports.length === 0;
  const assessmentReportsEmpty =
    !Boolean(vir.assessmentReports) || vir.assessmentReports.length === 0;
  const damagePackEmpty = damagePhotosEmpty || damagePhotosPdfEmpty || damagePhotosZipEmpty;
  const isDesktop = useMediaQuery("@media screen and (min-width: 768px)");

  const accodionDetailsClasses = isDesktop ? classes.details : classes.detailsDirectionColumn;
  const columnClasses = isDesktop ? classes.columnThird : classes.columnFull;
  const maxWidth = isDesktop ? undefined : "70vw";
  const hasAttachments =
    (vir.damagePhotos?.customer?.length ?? 0) > 0 ||
    (vir.damagePhotos?.staff?.length ?? 0) > 0 ||
    (vir.incidentReports?.length ?? 0) > 0 ||
    (vir.assessmentReports?.length ?? 0) > 0;
  return (
    <Accordion>
      <AccordionSummary
        aria-controls="panel1a-content"
        id="panel1a-header"
        expandIcon={<ExpandMoreIcon />}
      >
        <Typography className={classes.heading}>VIR {vir.reportNumber}</Typography>
      </AccordionSummary>
      <AccordionDetails className={accodionDetailsClasses}>
        <div className={columnClasses}>
          <Box>
            <strong>Accident Date & Time</strong>
            <Typography variant={"body2"}>{incideDateTimeString}</Typography>
          </Box>
          <Box>
            <strong>Accident Location</strong>
            <Typography variant={"body2"}>
              {!Boolean(vir.incidentDetails.address) ? "Not Filled" : vir.incidentDetails.address}
            </Typography>
          </Box>

          <Box>
            <strong>Description</strong>
            {damageDescriptionEmpty ? (
              <Typography variant={"body2"}>No Damage Codes</Typography>
            ) : (
              <ul className={classes.unOrderedList}>
                {vir.damageDetails.damageCodes.map((e, i) => (
                  <li key={i}>{e.description}</li>
                ))}
              </ul>
            )}
          </Box>
        </div>
        <div className={columnClasses}>
          <Box>
            <strong>Customer Driving</strong>
            <Typography variant={"body2"}>
              {vir.incidentDetails.renterDriving ? "Yes" : "No"}
            </Typography>
          </Box>
          <Box>
            <strong>Other Driver Last Name</strong>
            <Typography variant={"body2"}>
              {!Boolean(vir.otherDriverDetails) ||
                !Boolean(vir.otherDriverDetails.lastName) ||
                vir.otherDriverDetails.lastName === ""
                ? "Not Filled"
                : vir.otherDriverDetails.lastName}
            </Typography>
          </Box>
          <Box>
            <strong>Third Party Flag</strong>
            <Typography variant={"body2"}>
              {vir.thirdParty ||
                Boolean(vir.thirdPartyDetails) ||
                (vir.thirdPartyDetails?.length ?? 0) > 0
                ? "Yes"
                : "No"}
            </Typography>
          </Box>
          <Box>
            <strong>Third Party Last Name</strong>
            {!vir.thirdParty ||
              !Boolean(vir.thirdPartyDetails) ||
              (vir.thirdPartyDetails?.length ?? 0) === 0 ? (
              <Typography variant={"body2"}>No Third Party Information</Typography>
            ) : (
              <ul className={classes.unOrderedList}>
                {vir.thirdPartyDetails.map((e, i) => (
                  <li key={i}>{e.lastName}</li>
                ))}
              </ul>
            )}
          </Box>
        </div>
        <div className={columnClasses}>
          <Box>
            <strong>Vehicle Incident Report History</strong>
            {incidentReportsEmpty ? (
              <Typography variant={"body2"}>No Vehicle Incident Report</Typography>
            ) : (
              <ul className={classes.unOrderedList}>
                {vir.incidentReports.map((e, i) => {
                  const name = e.split("/").slice(-1)[0];
                  return (
                    <li key={i}>
                      <Link target="_blank" href={e}>
                        {name}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            )}
          </Box>
          <Box>
            <strong>Assessment Reports</strong>
            {assessmentReportsEmpty ? (
              <Typography variant={"body2"}>No Assessment Reports</Typography>
            ) : (
              <ul className={classes.unOrderedList}>
                {vir.assessmentReports.map((e, i) => {
                  const name = e.split("/").slice(-1)[0];
                  return (
                    <li key={i}>
                      <Link target="_blank" href={e}>
                        {name}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            )}
          </Box>
        </div>
        <div className={classes.columnFull}>
          <strong>Your Incident Photos</strong>
          {!Boolean(vir.damagePhotos) ||
            !Boolean(vir.damagePhotos.customer) ||
            vir.damagePhotos.customer.length === 0 ? (
            <Grid
              container
              style={{ maxHeight: "100%", overflow: "auto", maxWidth, flexFlow: "row" }}
            >
              <Typography variant={"body2"}>No photos uploaded</Typography>
            </Grid>
          ) : (
            <ImageList
              container
              md={12}
              cols={3.5}
              rows={1}
              rowHeight="100%"
              style={{ maxHeight: "100%", overflow: "auto", maxWidth, flexFlow: "row" }}
            >
              {vir.damagePhotos.customer.map((photo, index) => (
                <ImageListItem item key={index}>
                  <a
                    key={index}
                    onClick={(e) => handleAlbumClick(e, vir.damagePhotos.customer)}
                    style={{ display: "inline", cursor: "pointer" }}
                    value={index}
                  >
                    <img name={index} src={photo} width="70%" />
                  </a>
                </ImageListItem>
              ))}
            </ImageList>
          )}
        </div>
        <div className={classes.columnFull}>
          <strong>Our Incident Photos</strong>
          {!Boolean(vir.damagePhotos) ||
            !Boolean(vir.damagePhotos.staff) ||
            vir.damagePhotos.staff.length === 0 ? (
            <Grid
              container
              style={{ maxHeight: "100%", overflow: "auto", maxWidth, flexFlow: "row" }}
            >
              <Typography variant={"body2"}>No photos uploaded</Typography>
            </Grid>
          ) : (
            <ImageList
              container
              md={12}
              cols={3.5}
              rows={1}
              rowHeight="100%"
              style={{ maxHeight: "100%", overflow: "auto", maxWidth, flexFlow: "row" }}
            >
              {vir.damagePhotos.staff.map((photo, index) => (
                <ImageListItem item key={index}>
                  <a
                    key={index}
                    onClick={(e) => handleAlbumClick(e, vir.damagePhotos.staff)}
                    style={{ display: "inline", cursor: "pointer" }}
                    value={index}
                  >
                    <img name={index} src={photo} width="70%" />
                  </a>
                </ImageListItem>
              ))}
            </ImageList>
          )}
          <Box display="flex" justifyContent="center" alignItems="center" marginTop={"5px"}>
            {hasAttachments && (
              <RoundedButton
                variant="contained"
                color="primary"
                onClick={(e) => {
                  e.stopPropagation();
                  downloadAllAttachments(vir, rental);
                }}
                disabled={loading}
                style={{
                  marginLeft: "10px",
                  padding: "2px 8px",
                  minWidth: "auto",
                }}
              >
                {loading ? <CircularProgress /> : "Download Photos and PDF's Here"}
              </RoundedButton>
            )}
          </Box>
        </div>
      </AccordionDetails>
    </Accordion>
  );
};
const VIRAccordions = ({
  loadingStates = {},
  rental,
  virs,
  classes,
  damagePhotos,
  damagePhotosPdf,
  damagePhotosZip,
  handleAlbumClick,
  downloadAllAttachments,
}) => {
  const virsEmpty = virs === null || virs === undefined || virs.length === 0;
  if (virsEmpty) {
    return <h2>No Vehicle Incident Reports</h2>;
  }

  return virs.map((vir) => (
    <VIRAccordion
      key={vir.reportNumber}
      rental={rental}
      vir={vir}
      classes={classes}
      damagePhotos={damagePhotos}
      damagePhotosPdf={damagePhotosPdf}
      damagePhotosZip={damagePhotosZip}
      handleAlbumClick={handleAlbumClick}
      downloadAllAttachments={downloadAllAttachments}
      loading={Boolean(loadingStates[vir.reportNumber])}
    />
  ));
};

const VehicleIncidentReports = () => {
  const classes = useStyles();
  const currentRental = useCurrentRental();
  const [loadingStates, setLoadingStates] = useState({});

  const virs = currentRental.virs.filter(
    (e) => e.virStatus === "SUBMISSION_PAGE" || e.virStatus === "SUBMITTED"
  );
  const damagePhotos = _.get(currentRental, "damage_data.damage_photos_locations", []).filter(
    (p) => _.endsWith(p.toLowerCase(), ".jpg") || _.endsWith(p.toLowerCase(), ".png")
  );
  const damagePhotosZip = _.get(
    currentRental,
    "damage_data.damage_photos_locations",
    []
  ).filter((p) => _.endsWith(p.toLowerCase(), ".zip"));
  const damagePhotosPdf = _.get(
    currentRental,
    "damage_data.damage_photos_locations",
    []
  ).filter((p) => _.endsWith(p.toLowerCase(), ".pdf"));
  const [album, setAlbum] = useState([]);
  const [lightbox, setLightbox] = useState({ photoIndex: 0, isOpen: false });
  function handleAlbumClick(e, album) {
    setAlbum(album);
    setLightbox({ photoIndex: e.target.name, isOpen: true });
  }

  const downloadAllAttachments = async (vir, rental) => {
    if (!vir?.reportNumber) {
      return;
    }
    const countryDirectory = rental?.country.toLowerCase() == 'au' ? "damagepack" : "nz_damagepack";

    const reportNumber = vir.reportNumber;
    setLoadingStates((prev) => ({ ...prev, [reportNumber]: true }));

    try {
      const zip = new JSZip();
      const photosFolder = zip.folder("photos");
      const reportsFolder = zip.folder("reports");

      // Helper function to fetch and add files to ZIP
      const addFileToZip = async (url, folder, filename) => {
        try {
          console.log('addFileToZip url', url)
          const response = await fetch(url, { mode: "cors" });
          if (!response.ok) {
            throw new Error(`Failed to fetch: ${url}`);
          }
          const blob = await response.blob();
          folder.file(filename, blob);
        } catch (err) {
          console.error(`Error fetching ${filename}:`, err);
        }
      };

      // Process customer photos
      if (vir.damagePhotos?.customer?.length) {
        await Promise.all(
          vir.damagePhotos.customer.map((url, index) => {
            const filename = `customer_photo_${index + 1}.${url.split(".").pop()}`;
            // due to CORS errors for s3 jpg files, we fetch jpg files from damage pack if url includes 'hertz-damage-photos'
            if (url.includes('hertz-damage-photos')) {
              const jpgFile = decodeURIComponent(url.split('/').pop());
              url = `${fileURL}/view/${countryDirectory}/${vir.reportNumber}/${encodeURIComponent(jpgFile)}`
            }
            return addFileToZip(url, photosFolder, filename);
          })
        );
      }

      // Process staff photos
      if (vir.damagePhotos?.staff?.length) {
        await Promise.all(
          vir.damagePhotos.staff.map((url, index) => {
            const filename = `staff_photo_${index + 1}.${url.split(".").pop()}`;
            // due to CORS errors for s3 jpg files, we fetch jpg files from damage pack if url includes 'hertz-damage-photos'
            if (url.includes('hertz-damage-photos')) {
              const jpgFile = decodeURIComponent(url.split('/').pop());
              url = `${fileURL}/view/${countryDirectory}/${vir.reportNumber}/${encodeURIComponent(jpgFile)}`
            }
            // console.log('newUrl', url)
            return addFileToZip(url, photosFolder, filename);
          })
        );
      }

      // Process incident reports
      if (vir.incidentReports?.length) {
        await Promise.all(
          vir.incidentReports.map((entry) => {
            const reportUrl = isValidURL(entry)
              ? entry
              : `${fileURL}/view/incident_reports/${vir.reportNumber}/${entry}`;
            const name = reportUrl.split("/").pop();
            return addFileToZip(reportUrl, reportsFolder, name);
          })
        );
      }

      // Process assessment reports (including S3 URLs)
      if (vir.assessmentReports?.length) {
        await Promise.all(
          vir.assessmentReports.map((e) => {
            const isExternal = isValidURL(e);
            const rawUrl = isExternal
              ? e
              : `${fileURL}/view/${countryDirectory}/${vir.reportNumber}/${encodeURIComponent(
                e
              )}`;

            const encodedFileName = rawUrl.split("/").pop();
            const fileName = decodeURIComponent(encodedFileName);

            // Handle ALL URLs the same way (including S3)
            return addFileToZip(rawUrl, reportsFolder, fileName);
          })
        );
      }

      // Generate and download ZIP
      const content = await zip.generateAsync({ type: "blob" });
      downloadBlob(content, `VIR_${reportNumber}_attachments.zip`);
    } catch (error) {
      console.error("Error creating ZIP file:", error);
      alert("Failed to download attachments. Please try again.");
    } finally {
      setLoadingStates((prev) => {
        const newState = { ...prev };
        delete newState[reportNumber];
        return newState;
      });
    }
  };
  return (
    <Page className={classes.root} title="Damage Documentation - My Journey Portal">
      <Grid container direction="row" lg={10} sm={8} xl={10} xs={12}>
        <Grid item xs={12}>
          <Typography variant={"h1"} style={{ marginBottom: 30 }}>
            Vehicle Incident Reports
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography>
            The vehicle(s) associated with your rental{" "}
            <strong>(RA#{currentRental.rental_agreement_number})</strong> have been noted to have a
            vehicle incident report filed against them. Below you will find the details of the
            reported incident, along with any relevant photos and supporting evidence.
          </Typography>
        </Grid>
        <br />
        <br />
        <Grid item xs={12}>
          <Typography variant={"h2"} style={{ marginBottom: 10 }}>
            Vehicle {currentRental.vehicle.registration_number}
          </Typography>
          <VIRAccordions
            loadingStates={loadingStates}
            virs={virs}
            rental={currentRental}
            classes={classes}
            damagePhotosZip={damagePhotosZip}
            damagePhotos={damagePhotos}
            handleAlbumClick={handleAlbumClick}
            damagePhotosPdf={damagePhotosPdf}
            downloadAllAttachments={downloadAllAttachments}
          />
        </Grid>
      </Grid>
      {lightbox.isOpen && (
        <Lightbox
          mainSrc={album[lightbox.photoIndex]}
          nextSrc={album[(lightbox.photoIndex + 1) % album.length]}
          prevSrc={album[(lightbox.photoIndex + album.length - 1) % album.length]}
          onCloseRequest={() => setLightbox({ photoIndex: 0, isOpen: false })}
          onMovePrevRequest={() =>
            setLightbox({
              photoIndex: (lightbox.photoIndex + album.length - 1) % album.length,
              isOpen: true,
            })
          }
          onMoveNextRequest={() =>
            setLightbox({
              photoIndex: (lightbox.photoIndex + 1) % album.length,
              isOpen: true,
            })
          }
          reactModalStyle={{ zIndex: 2000 }}
        />
      )}
    </Page>
  );
};

export default VehicleIncidentReports;
